<template>
  <div
    ref="imageSet"
    :key="image.album_photo_id"
    class="image-set"
    :data-id="image.album_photo_id"
    :data-current-index="currentIndex"
    :data-index="index"
    :style="{
      width: imageSetWidthPx,
      height: imageSetHeightPx,
    }"
    :class="{
      active: expanded && active,
      inactive: expanded && !active,
      expanded: expanded,
      'no-margin-left': index === 0,
      skeleton: !imageLoaded,
    }"
  >
    <div
      v-if="visible"
      class="image-shadow"
      :style="{
        width: imageSetWidthPx - 24,
        height: imageSetHeightPx,
      }"
    >
      <div
        class="image-container desktop-image-container"
        :style="{
          height: imageHeightPx,
          width: imageHeightPx,
        }"
        :class="{
          'image-right': imageRight,
        }"
      >
        <!-- <div class="loader large" v-if="!imageLoaded && image.content_type == 'image'"></div> -->
        <div v-if="image.content_type === 'image'" class="image" :class="{ 'fade-in': imageLoaded }">
          <img :data-src="imageUrl" alt="" class="lazyload" @load="imageLoaded = true" />
        </div>
        <div v-if="image.content_type === 'video'" class="video">
          <video :src="image.source_image_url" :poster="image.large_image_url" :controls="active && expanded" muted playsinlnie></video>
        </div>
      </div>
      <div v-if="expanded && visible" ref="content" class="content">
        <div class="user">
          <div class="platform" :style="{ opacity: platformImage ? 1 : 0 }">
            <component :is="platformImage" />
          </div>
          <div class="vertical-divider" :class="[image.source]"></div>
          <div class="avatar">
            <img v-if="image.avatar_url" :data-src="image.avatar_url" alt="" class="lazyload" @error="image.avatar_url = ''" />
            <img v-else src="@/assets/ugc/profile.jpg" alt="" />
          </div>
          <a :href="platform_link" :target="image.platform_link ? '_blank' : '_self'" rel="noopener noreferrer ugc">
            <div class="name">@{{ image.user_name }}</div>
          </a>
          <a class="af af-close close" @click.passive="onCardCloseClicked"></a>
        </div>
        <div class="main">
          <div
            class="image-container mobile-image-container"
            :style="{
              width: imageHeightPx - 24,
            }"
          >
            <!-- <div class="loader large" v-if="!imageLoaded && image.content_type == 'image'"></div> -->
            <div v-if="image.content_type === 'image'" class="image" :class="{ 'fade-in': imageLoaded }">
              <img :data-src="imageUrl" alt="" class="lazyload" @load="imageLoaded = true" />
            </div>
            <div v-if="image.content_type === 'video'" class="video">
              <video :src="image.source_image_url" :poster="image.large_image_url" :controls="active" muted playsinline></video>
            </div>
          </div>
          <p class="photo-title">
            {{ image.photo_title }}
          </p>
          <div v-if="otherProducts.length" class="products">
            <template v-if="otherProducts.length > 1">
              <ImageGalleryArrow
                :left="true"
                :class="'product-position-left'"
                class="small-arrow"
                :size="1.5"
                :color="'#c5c5c5'"
                @click.passive="moveProductLeft()"
              ></ImageGalleryArrow>
              <ImageGalleryArrow
                :right="true"
                :class="'product-position-right'"
                class="small-arrow"
                :size="1.5"
                :color="'#c5c5c5'"
                @click.passive="moveProductRight()"
              ></ImageGalleryArrow>
            </template>
            <div v-for="(product, index) in otherProducts" v-show="index === currentOtherProductIndex" :key="product.sku" class="product">
              <a :href="product.link" :data-product-sku="product.sku">
                <img class="lazyload" :data-src="product.image" :alt="product.title" />
                <span class="title">{{ product.title }}</span>
              </a>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="social">
            <span class="af af-facebook" @click.passive="shareFacebook()"></span>
            <span class="af af-pinterest" @click.passive="sharePinterest()"></span>
            <span class="af af-twitter" @click.passive="shareTwitter()"></span>
          </div>
          <div class="report">
            <a href="https://www.pixlee.com/legal#dmca" target="_blank" rel="noopener noreferrer">Report</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageGalleryArrow from '@/components/ugc/ImageGalleryArrow.vue';

import FacebookIcon from '@/assets/ugc/facebook.svg';
import InstagramIcon from '@/assets/ugc/instagram.svg';
import TwitterIcon from '@/assets/ugc/twitter.svg';

export default {
  name: 'ImageGalleryCard',
  components: {
    ImageGalleryArrow,
  },
  props: {
    image: Object,
    maxImageWidth: Number,
    expanded: Boolean,
    onCardCloseClicked: Function,
    currentIndex: Number,
    index: Number,
    skuId: String,
    active: Boolean,
    interacted: Boolean,
    shareTitle: String,
  },
  data() {
    return {
      imageSetWidth: null,
      imageHeight: null,
      imageSetHeight: null,
      contentHeight: 300,
      imageUrl: '',
      platform_source_img: '',
      platform_link: '',
      imageLoaded: false,
      showReadMore: false,
      otherProducts: [],
      currentOtherProductIndex: 0,
      redirectUrl: '',
      articleShareUrl: '',
      breakPointMobile: 845,
      breakPointDesktop: 1300,
      imageUrls: ['source_image_url', 'large_image_url', 'small_image_url'],
      imageSources: ['facebook', 'instagram', 'twitter'],
      selectedImageUrlIndex: 0,
      visible: false,
    };
  },
  computed: {
    imageSetWidthPx() {
      return `${this.imageSetWidth}px`;
    },
    imageSetHeightPx() {
      return `${this.imageSetHeight}px`;
    },
    imageHeightPx() {
      return `${this.imageHeight}px`;
    },
    imageRight() {
      return this.currentIndex > this.index;
    },
    fitImageUrl: {
      get() {
        if ('connection' in window.navigator && 'downlink' in window.navigator.connection) {
          if (window.navigator.connection.downlink >= 0.8) {
            return this.image.large_image_url;
          }
          return this.image.small_image_url;
        }
        return this.isMobileAndGreater() ? this.image.large_image_url : this.image.small_image_url;
      },
    },
    platformImage() {
      const { source } = this.image;
      if (source === 'facebook') {
        return FacebookIcon;
      } else if (source === 'instagram') {
        return InstagramIcon;
      } else if (source === 'twitter') {
        return TwitterIcon;
      }
    }
  },
  watch: {
    maxImageWidth() {
      if (this.expanded) {
        this.imageSetWidth = this.maxImageWidth;
      }
    },
    expanded() {
      this.updateImageSetSize();
    },
  },
  mounted() {
    this.redirectUrl = `${window.location.origin}${window.location.pathname}?social_media_id=${this.image.album_photo_id}`;
    // eslint-disable-next-line no-script-url
    this.platform_link = this.image.platform_link ? this.image.platform_link : 'javascript:void(0)';

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.length) {
          this.visible = entries[0].isIntersecting;
          if (this.visible) {
            this.$emit('visible');
          }
        }
      },
      {
        rootMargin: '240px',
      },
    );
    this.observer.observe(this.$refs.imageSet);

    this.$nextTick(() => {
      this.updateImageSetSize();
      this.getOtherProduct();
      this.setImageUrl();
      this.expanded && this.updateImageSetSize();

      window.addEventListener('resize', this.onWindowResize, { passive: true });
      window.addEventListener('orientationchange', this.setTimeoutWindowResize, { passive: true });
      window.addEventListener('load', this.setImageUrl, { passive: true });
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
    window.removeEventListener('orientationchange', this.setTimeoutWindowResize);
    window.removeEventListener('load', this.setImageUrl);

    this.observer.unobserve(this.$refs.imageSet);
  },
  methods: {
    updateImageSetSize() {
      if (!this.expanded) {
        if (this.isMobileAndSmaller()) {
          this.imageSetWidth = 160;
          this.imageHeight = 160;
        } else {
          this.imageSetWidth = 240;
          this.imageHeight = 240;
        }
        this.imageSetHeight = this.imageHeight;
      } else {
        this.imageSetWidth = this.maxImageWidth;
        this.imageHeight = this.maxImageWidth;
        if (this.isMobileAndSmaller()) {
          this.imageSetHeight = window.innerHeight;
        } else {
          this.imageSetHeight = this.imageSetWidth;
          this.imageSetWidth += this.contentHeight;
        }
      }
    },
    getOtherProduct() {
      let { products } = this.image;
      if (products && products instanceof Array) {
        products = products.map((p) => {
          p.image = decodeURIComponent(p.image);
          p.title = decodeURIComponent(p.title);
          return p;
        });
        this.otherProducts = [...products]; // products.filter((p) => p.sku !== this.skuId);
      } else {
        this.otherProducts = [];
      }
    },
    moveProductRight() {
      if (this.currentOtherProductIndex < this.otherProducts.length - 1) {
        this.currentOtherProductIndex++;
      } else {
        this.currentOtherProductIndex = 0;
      }
    },
    moveProductLeft() {
      if (this.currentOtherProductIndex > 0) {
        this.currentOtherProductIndex--;
      } else {
        this.currentOtherProductIndex = this.otherProducts.length - 1;
      }
    },
    onWindowResize() {
      this.updateImageSetSize();
    },
    setTimeoutWindowResize() {
      setTimeout(this.onWindowResize, 250);
    },
    shareFacebook() {
      this.getShareUrl();
      let fbShareLink = 'https://www.facebook.com/sharer/sharer.php?u=';
      fbShareLink += encodeURIComponent(this.articleShareUrl);
      window.open(fbShareLink, '_blank');
    },
    sharePinterest() {
      // eslint-disable-next-line no-undef
      if ('PDK' in window) {
        // eslint-disable-next-line no-undef
        PDK.pin(this.imageUrl, this.image.photo_title.slice(0, 500), this.redirectUrl, () => {});
      }
    },
    shareTwitter() {
      this.getShareUrl();
      let twitterIntentUrl = 'https://twitter.com/intent/tweet?';
      const obj = {
        url: this.articleShareUrl,
        related: 'articlemodern',
      };
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(obj)) {
        twitterIntentUrl += key;
        twitterIntentUrl += '=';
        twitterIntentUrl += encodeURIComponent(value);
        twitterIntentUrl += '&';
      }
      window.open(twitterIntentUrl, '_blank');
    },
    getShareUrl() {
      const url = `//${window.location.host}${window.location.pathname}?social_media_id=${this.image.album_photo_id}`;
      const imageText = this.image.photo_title ? encodeURIComponent(this.image.photo_title) : '';
      const title = this.shareTitle ? encodeURIComponent(this.shareTitle) : 'Article';
      this.articleShareUrl = `${window.location.protocol}//${window.location.host}/api/ugc/share?imageText=${imageText}&imageUrl=${this.imageUrl}&title=${title}&url=${url}`;
    },
    setImageUrl() {
      if (this.image.content_type === 'image') {
        if ('connection' in window.navigator && 'downlink' in window.navigator.connection) {
          const { downlink } = window.navigator.connection;
          if (downlink >= 2) {
            this.selectedImageUrlIndex = 0;
          } else if (downlink >= 0.8) {
            this.selectedImageUrlIndex = 1;
          } else {
            this.selectedImageUrlIndex = 2;
          }
        } else {
          this.selectedImageUrlIndex = this.isDesktopAndGreater() ? 0 : 1;
        }
        this.imageUrl = this.image[this.imageUrls[this.selectedImageUrlIndex]];
      } else {
        this.imageUrl = this.image[this.imageUrls[2]];
      }
    },
    isMobileAndSmaller() {
      return window.matchMedia(`(max-width: ${this.breakPointMobile - 1}px)`).matches;
    },
    isMobileAndGreater() {
      return window.matchMedia(`(min-width: ${this.breakPointMobile}px)`).matches;
    },
    isDesktopAndGreater() {
      return window.matchMedia(`(min-width: ${this.breakPointDesktop}px)`).matches;
    },
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

$ugc-mobile-breakpoint: 845px;
$ugc-desktop-breakpoint: 1300px;

.image-set {
  width: 240px;
  height: 240px;
  margin: 0px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  transform: translateZ(0);
  overflow: initial;
  position: relative;

  &.skeleton {
    margin: 1px;
  }

  @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
    width: 160px;
    height: 160px;
  }

  &,
  * {
    backface-visibility: hidden;
  }

  &.no-margin-right {
    margin-right: 0;
  }

  &.no-margin-left {
    margin-left: 0;
  }

  .image-shadow {
    position: relative;
  }

  &.expanded {
    position: relative;
    box-sizing: border-box;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;

    @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
      border: none;

      .image-shadow {
        position: relative;
      }
    }

    .image-container,
    .content {
      position: absolute;

      @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
        padding: 0px;
        position: static;
      }
    }

    @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
      .desktop-image-container {
        display: none;
      }
      .mobile-image-container {
        position: static;
        display: inherit;
        flex-grow: 1;
      }
    }

    @media (min-width: $ugc-mobile-breakpoint) {
      .mobile-image-container {
        display: none;
      }
    }

    .image-container {
      cursor: default;
      background-color: var(--background-color);

      &.image-right {
        left: auto;
        right: 0;
      }

      @media (min-width: $ugc-mobile-breakpoint) {
        left: 0;
        height: 100%;
        width: 388px;
      }

      .image {
        @supports (display: flex) {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        img {
          opacity: 0.2;
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }

      .video {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }

  .small-arrow {
    box-shadow: none;
  }

  /* purgecss ignore */
  &:not(.expanded) {
    .image-container {
      border: 1px solid transparent;
    }
  }

  .image-container {
    position: relative;
    width: 100%;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: left 200ms linear;
    cursor: pointer;
    box-sizing: border-box;
    overflow: hidden;

    .loader {
      position: absolute;
    }

    .image {
      position: relative;
      width: 100%;
      height: 100%;
      opacity: 0;

      transition: opacity 100ms linear;
      overflow: hidden;
      box-sizing: border-box;

      &.fade-in {
        opacity: 1;

        img {
          opacity: 1;
        }
      }

      img {
        position: relative;
        opacity: 1;
        width: 100%;
        height: 100%;
        margin: auto;
        object-fit: cover;

        transition: opacity 100ms linear;
      }
    }

    .video {
      width: 100%;
      height: 100%;

      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  &.active {
    .image-shadow {
      box-shadow: 0 var(--box-shadow-blur) var(--box-shadow-spread) rgba(0, 0, 0, 0.2);
    }

    .content {
      visibility: visible;
      opacity: 1;

      transition: opacity 250ms linear;

      @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
        left: 0;
        right: 0;
        top: 0;
        height: 100%;
      }
    }
  }

  &.expanded {
    opacity: 1;
    transition: opacity ease-out 300ms;
  }

  &.active.expanded {
    .image-container {
      .image {
        img {
          opacity: 1;
        }
      }
    }
  }

  &.inactive.expanded {
    opacity: 0.2;
  }

  .content {
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: flex-start;
    box-sizing: border-box;
    height: 100%;
    border: none;
    padding: 16px;
    z-index: 0;
    transition: height 250ms ease-out, opacity 250ms ease-out, visibility 0s ease-out 250ms;

    @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
      padding-top: 0px;
    }

    @media (min-width: $ugc-mobile-breakpoint) {
      right: 0;
      width: 280px;
      opacity: 0;
      visibility: hidden;
    }

    .close {
      position: absolute;
      right: 8px;
      padding: 12px;
      font-size: 1em;
      z-index: 2;
      background-color: var(--white);
    }

    .user {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      flex: 0 0 auto;

      @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
        margin: 16px;
      }

      @media (min-width: $ugc-desktop-breakpoint) {
        margin-top: 20px;
      }

      .platform {
        width: 32px;
        padding-right: 8px;
        flex-shrink: 0;
        display: flex;
        align-items: center;

        img {
          color: transparent;
        }
      }

      .vertical-divider {
        height: 36px;
        margin-right: 8px;

        &.instagram {
          border-right: 1px solid #d63086;
        }

        &.twitter {
          border-right: 1px solid #1da1f2;
        }

        &.facebook {
          border-right: 1px solid #3b5998;
        }
      }

      .avatar {
        width: 32px;
        height: 32px;
        margin-right: 8px;
        border-radius: 50%;

        @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
          width: 32px;
          height: 32px;
        }

        img {
          color: transparent;
          max-width: 100%;
          min-width: 32px;
          height: 100%;
          border-radius: 50%;
        }
      }

      .name {
        font-weight: bold;
        width: 130px;
        overflow-x: hidden;
        text-overflow: ellipsis;
        letter-spacing: 1px;

        @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
          width: calc(100vw - 230px);
          font-size: var(--font-size-16);
        }
      }
    }

    .main {
      display: flex;
      flex-direction: column;
      flex-grow: 1;

      /* FireFox has issue setting correct flex size */
      min-height: 0;

      .photo-title {
        margin: 0;
        flex: 1;
        overflow-y: auto;
        font-size: var(--font-size-16);
        line-height: 1.3em;
        overflow-wrap: break-word;

        @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
          display: none;
        }

        @media (min-width: $ugc-desktop-breakpoint) {
          flex: 3;
          line-height: 1.5em;
        }
      }

      .products {
        position: relative;
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        padding: 12px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 24px;
        flex-shrink: 0;
        flex-grow: 0;

        @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
          padding: 36px 0 40px;
          margin: 0px;
          border-top: none;
        }

        .product-position-left,
        .product-position-right {
          font-size: 1em;
          top: 30%;
          display: flex;
          justify-content: center;
          span {
            align-self: center;
          }
        }

        .product-position-left {
          left: -14px;

          @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
            left: 0;
          }
        }

        .product-position-right {
          right: -14px;

          @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
            right: 0;
          }
        }

        .product {
          display: flex;
          justify-content: center;
          width: 90%;
          flex: 1;
          max-width: 100%;

          a {
            max-width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
              flex-direction: row;
              max-width: 70%;
            }

            img {
              color: transparent;
              max-width: 120px;

              @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
                margin-right: 12px;
              }
            }

            .title {
              font-size: var(--font-size-14);
              text-align: center;
              line-height: 18px;
              margin-top: 4px;
              color: var(--font-color);
              max-width: 70%;
              :hover {
                color: var(--font-color);
              }
              @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
                font-size: var(--font-size-14);
              }
            }
          }
        }
      }
    }

    .footer {
      display: flex;
      align-items: flex-end;
      flex: 0 0 auto;
      padding-top: 12px;

      @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
        padding: 16px;
      }

      .social {
        display: flex;
        align-items: center;

        span {
          cursor: pointer;
          font-size: 1.7em;
          color: var(--grey-light);
          margin-right: 6px;

          @media (max-width: calc($ugc-mobile-breakpoint - 1px)) {
            font-size: 1.5em;
          }
        }
      }

      .report {
        color: var(--grey-light);
        padding-left: 24px;

        a {
          font-size: var(--font-size-14);
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
